import { useField } from 'formik';
import React, { FC } from 'react';
import { GENDER_OPTIONS, GENDER_TRANSLATION } from '../';
import { Form } from 'react-bootstrap';

interface IGenderProps {
  name: string;
}

export const GenderField: FC<IGenderProps> = ({ name }) => {
  const [{ value }, , { setValue }] = useField(name);

  const handleGenderChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setValue(event.currentTarget.id);
  };

  return (
    <Form.Group>
      {GENDER_OPTIONS.map((gender) => (
        <Form.Check
          as="input"
          checked={gender === value}
          onChange={handleGenderChange}
          id={gender}
          key={gender}
          type="radio"
          name="gender"
          label={GENDER_TRANSLATION[gender]}
        />
      ))}
    </Form.Group>
  );
};
